import { statuses } from '@/returns/constants'

const isItemDeclarable = item => !item.cancelled_from_draft

const isItemRejected = item => item.status === statuses.rejected

const getLineItemsFromGroups = lineItemGroups => {
  if (!lineItemGroups?.length) return []

  return lineItemGroups.flatMap(group => {
    if (!group.line_items?.length) return []

    return group.line_items
  })
}

const getDeclarableItems = (lineItems, lineItemGroups) => {
  const ungroupedItems = lineItems?.length ? lineItems : []

  return [...ungroupedItems, ...getLineItemsFromGroups(lineItemGroups)].filter(isItemDeclarable)
}

export const getShipmentDeclaration = ({ lineItems, lineItemGroups, includeRejectedItems }) => {
  const declarableItems = getDeclarableItems(lineItems, lineItemGroups)
  const rejectedItems = declarableItems.filter(isItemRejected)
  const isAllRejected = rejectedItems.length > 0 && rejectedItems.length === declarableItems.length
  const declaresRejectedItems = isAllRejected || !!includeRejectedItems

  return {
    includedItems: declaresRejectedItems ? declarableItems : declarableItems.filter(item => !isItemRejected(item)),
    rejectedCount: rejectedItems.length,
    isAllRejected,
    isPartiallyRejected: rejectedItems.length > 0 && !isAllRejected,
    declaresRejectedItems,
  }
}

export const shouldIncludeRejectedItems = data => {
  const declaration = getShipmentDeclaration({
    lineItems: data?.line_items,
    lineItemGroups: data?.line_item_groups,
    includeRejectedItems: data?.shipping?.includes_rejected_items,
  })

  return declaration.declaresRejectedItems
}
